/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PutApiV1BannerIdMutationRequest,
  PutApiV1BannerIdMutationResponse,
  PutApiV1BannerIdPathParams,
  PutApiV1BannerId400,
  PutApiV1BannerId401,
  PutApiV1BannerId404,
  PutApiV1BannerId500,
} from "../../types/bannerRegistroController/PutApiV1BannerId.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { putApiV1BannerId } from "../../clients/bannerRegistroController/putApiV1BannerId.ts";

export const putApiV1BannerIdMutationKey = () =>
  [{ url: "/api/v1/banner/:id" }] as const;

export type PutApiV1BannerIdMutationKey = ReturnType<
  typeof putApiV1BannerIdMutationKey
>;

export function putApiV1BannerIdMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PutApiV1BannerIdMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const mutationKey = putApiV1BannerIdMutationKey();
  return mutationOptions<
    PutApiV1BannerIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1BannerId400
      | PutApiV1BannerId401
      | PutApiV1BannerId404
      | PutApiV1BannerId500
    >,
    {
      id: PutApiV1BannerIdPathParams["id"];
      data?: PutApiV1BannerIdMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id, data }) => {
      return putApiV1BannerId(id, data, config);
    },
  });
}

/**
 * @description Atualiza os dados de um banner (multipart/form-data). Envie 'image' para substituir a imagem ou use os flags de remoção. **(Requer Authorization para autenticação)**
 * @summary Atualizar banner (Requer Authorization para autenticação)
 * {@link /api/v1/banner/:id}
 */
export function usePutApiV1BannerId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PutApiV1BannerIdMutationResponse,
      ResponseErrorConfig<
        | PutApiV1BannerId400
        | PutApiV1BannerId401
        | PutApiV1BannerId404
        | PutApiV1BannerId500
      >,
      {
        id: PutApiV1BannerIdPathParams["id"];
        data?: PutApiV1BannerIdMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PutApiV1BannerIdMutationRequest>> & {
      client?: Client;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? putApiV1BannerIdMutationKey();

  const baseOptions = putApiV1BannerIdMutationOptions(
    config,
  ) as UseMutationOptions<
    PutApiV1BannerIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1BannerId400
      | PutApiV1BannerId401
      | PutApiV1BannerId404
      | PutApiV1BannerId500
    >,
    {
      id: PutApiV1BannerIdPathParams["id"];
      data?: PutApiV1BannerIdMutationRequest;
    },
    TContext
  >;

  return useMutation<
    PutApiV1BannerIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1BannerId400
      | PutApiV1BannerId401
      | PutApiV1BannerId404
      | PutApiV1BannerId500
    >,
    {
      id: PutApiV1BannerIdPathParams["id"];
      data?: PutApiV1BannerIdMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PutApiV1BannerIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1BannerId400
      | PutApiV1BannerId401
      | PutApiV1BannerId404
      | PutApiV1BannerId500
    >,
    {
      id: PutApiV1BannerIdPathParams["id"];
      data?: PutApiV1BannerIdMutationRequest;
    },
    TContext
  >;
}
